import { useEffect, useRef, useState } from 'react';
import { ordersApi, RescheduleOptions } from '../../services/ordersApi';

const DEBOUNCE_MS = 300;

/**
 * Spec 077 — the options for the date being looked at: fetched on open (no wait) and again on every
 * date change after a short pause. A slow earlier answer never overwrites a newer one.
 */
export function useRescheduleOptions(orderId: string, date: string, token: string | null) {
  const [options, setOptions] = useState<RescheduleOptions | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const seq = useRef(0);
  const first = useRef(true);

  useEffect(() => {
    if (!token || !date) return;
    const mySeq = ++seq.current;
    setLoading(true);
    const timer = setTimeout(() => {
      ordersApi.getRescheduleOptions(orderId, date, token)
        .then((res) => {
          if (seq.current !== mySeq) return;
          setOptions(res);
          setError(null);
        })
        .catch((err) => {
          if (seq.current !== mySeq) return;
          setError(err instanceof Error ? err.message : 'Could not load the reschedule options.');
        })
        .finally(() => {
          if (seq.current === mySeq) setLoading(false);
        });
    }, first.current ? 0 : DEBOUNCE_MS);
    first.current = false;
    return () => clearTimeout(timer);
  }, [orderId, date, token]);

  return { options, loading, error };
}
